import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { useMouseScrubVideo } from './useMouseScrubVideo';
import { CLOSING_VIDEO, CLOSING_POSTER } from './ScrubVideoPlate';
import { useCopy } from './copy/copyMode';
import { WaitlistCTA } from './WaitlistCTA';
export function ClosingCTA() {
  const copy = useCopy();
  const videoRef = useMouseScrubVideo<HTMLVideoElement>();
  return <section className="relative w-full overflow-hidden bg-[#2B211A] min-h-[500px] lg:min-h-[640px] flex items-center py-20 lg:py-0" data-id="element-2237" data-mp="3axzn6lfg7ofj">
      {/* Background Video — hidden on mobile, where the section is just a solid
                           brown background for a cleaner, faster read. The video
                           is mouse-scrubbed (it never autoplays), so a `poster`
                           guarantees a designed still frame is always painted —
                           otherwise the element renders blank until the visitor
                           moves their cursor and the browser paints a seek.
                           preload MUST be "metadata" (not "none"): the scrub hook
                           paints the first frame on `loadedmetadata` and needs
                           `video.duration` to seek. "none" loads neither, so the
                           video renders blank AND scrubbing is dead — but
                           "metadata" only fetches a few KB, not the full 12 MB,
                           so the optimization still holds. */}
      {/* object-position is anchored to the TOP of the frame, not the centre.
       The section is wide and short, so object-cover crops vertically — and
       centring the crop cut the figure's head off, which is the part that
       carries the scrub interaction. Held at 78% horizontally so the figure
       sits in the empty right half, clear of the headline. */}
      <video ref={videoRef} src={CLOSING_VIDEO} poster={CLOSING_POSTER} muted playsInline preload="metadata" className="hidden md:block absolute inset-0 w-full h-full bg-[#2B211A] object-cover object-[78%_top]" data-id="element-2238" data-mp="3lkpw881pw8sp" />

      {/* Subtle overlays — desktop only (mobile is solid brown). */}
      <div className="hidden md:block absolute inset-0 bg-black/20 pointer-events-none" data-id="element-2239" data-mp="j75l0ttqoi2z" />
      <div className="hidden md:block absolute inset-0 bg-gradient-to-r from-[#2B211A]/80 via-transparent to-transparent pointer-events-none" data-id="element-2240" data-mp="o2unp6122f3i" />

      <div className="max-w-[1280px] mx-auto px-6 md:px-10 relative z-10 w-full" data-id="element-2241" data-mp="y2va50u81bbx">
        <div className="lg:w-1/2 lg:pr-12 flex flex-col items-start text-left lg:items-start lg:text-left" data-id="element-2242" data-mp="123x698sud79o">
          <motion.h2 initial={{
          opacity: 0,
          y: 8
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.45,
          ease: [0.22, 1, 0.36, 1]
        }} className="font-title font-medium text-4xl md:text-6xl lg:text-7xl tracking-tight text-white leading-[1.05]" data-id="element-2243" data-mp="16ux2ebu4zlb4">
            {copy.closingCta.headline}
          </motion.h2>

          <motion.p initial={{
          opacity: 0,
          y: 8
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.45,
          delay: 0.06,
          ease: [0.22, 1, 0.36, 1]
        }} className="mt-5 md:mt-7 text-base md:text-xl text-white/80 max-w-lg leading-relaxed" data-id="element-2244" data-mp="36bjjeeeqqq5k">
            Do less. Finish more.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 8
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.45,
          delay: 0.12,
          ease: [0.22, 1, 0.36, 1]
        }} className="mt-7 md:mt-9 flex flex-col items-start gap-4" data-id="element-2245" data-mp="3k1d9f01zfggv">
            <WaitlistCTA analyticsLabel="closing" className="bg-[#EA580C] hover:bg-[#C2410C] text-white px-9 py-4 rounded-full font-bold text-lg transition-colors shadow-[0_0_30px_rgba(234,88,12,0.4)]" data-id="element-2246" data-mp="bn4nubxvnpy7">
              Get started for free
            </WaitlistCTA>
            {/* The offer, not a countdown. A trial clock is a reason to delay
             signing up until you have time to use it; credit that does not
             expire is a reason to start now. */}
            <p className="text-sm text-white/80 font-medium" data-id="element-2247" data-mp="3iibmaablvtfk">
              $100 in credits free · No card required
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}